module.exports = __webpack_public_path__ + "media/notification.4d935a0c.mp3";